import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ImageIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M9 7.36526C9.55228 7.36526 10 6.91754 10 6.36526C10 5.81298 9.55228 5.36526 9 5.36526C8.44772 5.36526 8 5.81298 8 6.36526C8 6.91754 8.44772 7.36526 9 7.36526Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2 4.11526C2 2.59648 3.23122 1.36526 4.75 1.36526H11.25C12.7688 1.36526 14 2.59648 14 4.11526V12.6153C14 14.1341 12.7688 15.3653 11.25 15.3653H4.75C3.23122 15.3653 2 14.1341 2 12.6153V4.11526ZM4.75 2.86526C4.05964 2.86526 3.5 3.4249 3.5 4.11526V10.2819L5.24074 8.25106C5.63984 7.78545 6.36016 7.78545 6.75926 8.25106L9 10.8653L10.6263 9.03568C10.8252 8.81192 11.1748 8.81192 11.3737 9.03568L12.5 10.3028V4.11526C12.5 3.4249 11.9404 2.86526 11.25 2.86526H4.75Z"
		/>
	</svg>
))
